import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import Button from '../../../components/ui/Button';

// Devam Paneli süzgeçleri uygulanıyor şeridi (ObPeriodApprovalsPage afiş görünümü). Niyetten değil GERÇEKTEN uygulanan
// istek parametrelerinden türetilir: kullanıcı tabloda kendi tarihini seçtiyse panel tarihi yazılmaz. Süzgeç adı yerine
// türü yazılır (ek istek atılmaz).
const Banner = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  background: #eff8ff;
  border: 1px solid #bfe3fb;
  color: #0f5c8f;
  border-radius: 6px;
  padding: 9px 14px;
  font-size: 13px;
  margin: 0 0 14px;
  flex-shrink: 0;
`;

const Detail = styled.span`
  color: #1c5cab;
`;


const TYPE_LABEL = {
  departmentId: 'taReports.preset.department',
  locationId: 'taReports.preset.location',
  userGroupId: 'taReports.preset.userGroup',
  employeeStatusId: 'taReports.preset.employeeStatus',
};

const formatDay = (iso, lang) => {
  const [y, m, d] = iso.split('-').map(Number);
  return new Intl.DateTimeFormat(lang || 'tr', { day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'UTC' })
    .format(new Date(Date.UTC(y, m - 1, d)));
};

export default function PresetFilterBanner({ preset, queryParams, onClear }) {
  const { t, i18n } = useTranslation();
  if (!preset || !queryParams) return null;

  const dateApplied = Boolean(preset.from && preset.to && queryParams['date[between]'] === `${preset.from},${preset.to}`);
  const types = Object.keys(TYPE_LABEL).filter((key) => preset[key] && queryParams[key] === preset[key]);
  if (!dateApplied && types.length === 0) return null;

  const details = [
    dateApplied ? t('taReports.preset.dateRange', {
      from: formatDay(preset.from, i18n.language), to: formatDay(preset.to, i18n.language),
    }) : null,
    ...types.map((key) => t(TYPE_LABEL[key])),
  ].filter(Boolean).join(' · ');

  return (
    <Banner data-preset-banner>
      <span>{t('taReports.preset.banner')}</span>
      {details ? <Detail>{details}</Detail> : null}
      {/* Paylaşılan düğme (inceleme M10) — elle yazılmış bağlantı düğmesi yerine. */}
      <Button type="button" variant="ghost" data-action="clear-preset" onClick={onClear}>{t('taReports.preset.clear')}</Button>
    </Banner>
  );
}
